import { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./tabs.scss";

export class Tabs extends Component {
    static propTypes = {
        selectTab: PropTypes.func.isRequired,
        sections: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        active: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderTabs = (sections) => {
        const tabs = sections.map(({ name, alias, details, disabled }) => (
            <div
                key={alias}
                className={classNames("recon3-tab", { [alias]: !disabled, active: alias === this.props.active, disabled })}
                onClick={disabled ? () => {} : this.props.selectTab.bind(null, { display: { section: alias } })}
            >
                <div className="header">{name}</div>
                <div className="details">{details}</div>
            </div>
        ));

        return (
            <div className={classNames("recon3-tabs-header", this.props.active)}>
                <div className="custom-header">
                    {this.props.customHeader}
                </div>
                <div className="tabs-buttons">
                    {tabs}
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className={classNames(["recon3-tabs", "root", this.props.className])}>
                {this.renderTabs(this.props.sections)}
                <div key="body" className="recon3-tabs-body">{this.props.children}</div>
            </div>
        );
    }
}
